// A date without a kickoff is a calendar day, not a timezone-shifted instant.
export const footballCalendarDate = (value, options = { weekday: 'short', day: 'numeric', month: 'short' }) => {
  const day = String(value || '').slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(day)) return '';
  return new Intl.DateTimeFormat('sv-SE', options).format(new Date(`${day}T12:00:00`));
};
